import FormSetup from '../../../../shared/js/components/FormSetup'
import AddressLines from '../shared/AddressLines'
import Dialog from '../shared/Dialog'
import React, { useState } from 'react'
import type { AddressProps } from '../../shared/Module'
import type { SyntheticEvent } from 'react'

interface AddressDialogProps extends AddressProps {
  url: string
}

const AddressDialogLink = ({ url, ...address }: AddressDialogProps) => {
  const [opened, setOpened] = useState(false)

  return (
    <>
      <a
        href='#'
        className='c-link lb-btn lb-btn-type-4'
        onClick={toggleDialog}
        aria-haspopup='dialog'
      >
        Supprimer
      </a>
      <Dialog
        className='right-modal'
        onCancel={toggleDialog}
        opened={opened}
        title='Suppression de l’addresse'
      >
        <form action={url} method='post'>
          <FormSetup method='DELETE' />
          <p>Souhaitez-vous vraiment supprimer l’adresse suivante :</p>
          <div className='c-background-block'>
            <AddressLines {...address} separator={<br />} />
          </div>

          <div className='right-action-modal__btn'>
            <button
              className='lb-btn lb-btn-type-6'
              type='button'
              onClick={toggleDialog}
            >
              Annuler
            </button>
            <button
              name='button'
              type='submit'
              className='lb-btn lb-btn-type-1'
            >
              Oui, supprimer cette adresse
            </button>
          </div>
        </form>
      </Dialog>
    </>
  )

  function toggleDialog(event: SyntheticEvent) {
    event.preventDefault()
    setOpened(!opened)
  }
}

export default AddressDialogLink
